import { useCallback } from "react";
import { SchedulePeriodLockedError } from "@api/scheduleErrors";
import { useToaster } from "@design-system/ToastMessages/useToaster";
import type { ShowLockedPeriods } from "./useScheduleLockedPeriodsDialog";

/**
 * An accrued invoice, bill or payment schedule whose back-dated start is
 * locked gets a toast naming the months to unlock instead of the
 * locked-periods dialog. Returns whether the error was that case.
 */
export function useAccruedLockedStartToast(): ShowLockedPeriods {
    const { error } = useToaster();
    return useCallback(
        (caught: unknown): boolean => {
            if (
                !(caught instanceof SchedulePeriodLockedError) ||
                !caught.details.accruedStartLockedMonths?.length
            ) {
                return false;
            }
            error(caught.details.message);
            return true;
        },
        [error],
    );
}
